import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { PadContainer, HorizontalFlex } from 'smartsuite-ui';
import { getDataPromise } from 'brock-fetch-utils';
import DashboardContext from '../../shared/hooks/dashboardContext';
import { useLabelContext } from '../../shared/hooks/labelContext';
import WidgetLoading from '../../shared/WidgetLoading';
import WidgetErrorMessage from '../../viewDashboards/widgets/WidgetErrorMessage';

function hydrateLinks(link, openLinksInNewTab, getNonApiUri) {
    return {
        displayText: link.displayText,
        icon: link.icon,
        target: openLinksInNewTab ? '_blank' : '',
        uri: link.isAbsoluteUri ? link.path : getNonApiUri(link.path),
        sortOrder: link.sortOrder,
    };
}

/* eslint-disable complexity */
function UserFavorites(props) {
    const { dashboardLabels } = useLabelContext();
    const {
        favoriteUtilities: { getLandingPageWidgetUserFavorites },
        uriConstants,
    } = useContext(DashboardContext);

    const [errorMessage, setErrorMessage] = useState(null);
    const [userFavorites, setUserFavorites] = useState(null);

    useEffect(() => {
        const userFavoritesPromise = getLandingPageWidgetUserFavorites
            ? getLandingPageWidgetUserFavorites()
            : getDataPromise(uriConstants.getUserFavorites);

        userFavoritesPromise.then(setUserFavorites, () =>
            setErrorMessage(dashboardLabels.userFavoritesUnavailable)
        );
    }, [
        dashboardLabels.userFavoritesUnavailable,
        getLandingPageWidgetUserFavorites,
        uriConstants.getUserFavorites,
    ]);

    if (errorMessage) {
        return <WidgetErrorMessage>{errorMessage}</WidgetErrorMessage>;
    }

    if (!userFavorites) {
        return <WidgetLoading />;
    }

    if (!userFavorites.length) {
        return (
            <WidgetErrorMessage>
                {dashboardLabels.missingData}
            </WidgetErrorMessage>
        );
    }

    const linksWithFullUri = userFavorites.map((link) =>
        hydrateLinks(link, props.openLinksInNewTab, uriConstants.getNonApiUri)
    );

    return (
        <PadContainer cssClassModifiers={['pad-small', 'no-pad-top']}>
            {linksWithFullUri.map((link) => (
                <PadContainer
                    key={link.displayText}
                    cssClassModifiers={['pad-medium', 'no-pad-top']}
                >
                    <HorizontalFlex>
                        {link.icon && (
                            <PadContainer
                                cssClassModifiers={[
                                    'pad-medium',
                                    'no-pad-top-bottom',
                                    'no-pad-left',
                                ]}
                            >
                                <span className={link.icon} />
                            </PadContainer>
                        )}
                        <a href={link.uri} target={link.target}>
                            {link.displayText}
                        </a>
                    </HorizontalFlex>
                </PadContainer>
            ))}
        </PadContainer>
    );
}
/* eslint-enable complexity */

UserFavorites.propTypes = {
    openLinksInNewTab: PropTypes.bool.isRequired,
};

export default UserFavorites;
